// extracted by mini-css-extract-plugin
module.exports = {"container":"Centered_container__2x90e"};